<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'schedule-page',
};
</script>
